<script setup lang="ts">
import type { HoverExpandButtonProps } from '.';

import { cn } from '@/utils';
import { Primitive } from 'reka-ui';

withDefaults(defineProps<HoverExpandButtonProps>(), {
	as: 'button'
});

const slots = useSlots();
const hasTitle = computed(() => !!slots.title);
</script>

<template>
	<Primitive
		v-bind="$attrs"
		:as="as"
		:as-child="asChild"
		:class="
			cn(
				'group inline-flex cursor-pointer items-center justify-start whitespace-nowrap rounded-full font-medium focus:outline-none focus-visible:outline-none',
				'bg-primary/40 text-white border-transparent hover:[@media(hover:hover)]:bg-black',
				'py-3 px-3 gap-3',
				$attrs.class as string
			)
		"
	>
		<div
			:class="
				cn('flex items-center overflow-hidden', { 'size-full': !hasTitle })
			"
		>
			<div
				:class="
					cn(
						'flex shrink-0 items-center justify-center text-white transition-colors duration-150 ease-out group-hover:[@media(hover:hover)]:text-beige',
						{ 'size-5': hasTitle, 'size-full': !hasTitle }
					)
				"
			>
				<slot name="icon"></slot>
			</div>

			<div
				v-if="hasTitle"
				class="max-w-0 overflow-hidden transition-all duration-300 ease-in-out group-hover:[@media(hover:hover)]:max-w-xs"
			>
				<span
					class="ml-2 block translate-x-2 whitespace-nowrap text-sm font-medium leading-5 tracking-normal text-white opacity-0 transition-all duration-300 ease-in-out group-hover:[@media(hover:hover)]:translate-x-0 group-hover:[@media(hover:hover)]:opacity-100"
				>
					<slot name="title"></slot>
				</span>
			</div>
		</div>
	</Primitive>
</template>
